module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entries.js
// module id = 1851
// module chunks = 1